import React from 'react'

export const IconUsdt = (props = {}) => {
	const {size = 24, imgSize= 24, fill = "white", fillBg = "#26A17B"} = props
	return (
		<svg xmlns="http://www.w3.org/2000/svg"
				 width={`${size}px`}
				 height={`${size}px`}
				 viewBox={`0 0 ${imgSize} ${imgSize}`}
				 fill="none"
		>
			<g clipPath="url(#clip0_1_1861)">
				<path
					d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
					fill={fillBg}
				/>
				<path fillRule="evenodd" clipRule="evenodd"
							d="M13.4416 13.0373V13.0358C13.3591 13.0418 12.9338 13.0673 11.9851 13.0673C11.2276 13.0673 10.6943 13.0448 10.5068 13.0358V13.038C7.59085 12.9098 5.41435 12.402 5.41435 11.7945C5.41435 11.1878 7.59085 10.68 10.5068 10.5495V12.5325C10.6973 12.546 11.2433 12.5783 11.9978 12.5783C12.9031 12.5783 13.3568 12.5408 13.4416 12.5333V10.551C16.3516 10.6808 18.5228 11.1885 18.5228 11.7945C18.5228 12.402 16.3516 12.9083 13.4416 13.0373ZM13.4416 10.3448V8.57026H17.5021V5.86426H6.44635V8.57026H10.5068V10.344C7.20685 10.4955 4.7251 11.1495 4.7251 11.9325C4.7251 12.7155 7.20685 13.3688 10.5068 13.521V19.2075H13.4416V13.5195C16.7363 13.368 19.2121 12.7148 19.2121 11.9325C19.2121 11.1503 16.7363 10.497 13.4416 10.3448Z"
							fill={fill}/>
			</g>
			<defs>
				<clipPath id="clip0_1_1861">
					<rect
						width={`${size}px`}
						height={`${size}px`}
						fill={fill}
					/>
				</clipPath>
			</defs>
		</svg>
	)
}